const styles = () => `
  &.vds-menu-curtain {
    background-color: transparent !important;
    display: none;
    height: 100%;
    left: 0;
    position: relative;
    top: 0;
    width: 100%;
    z-index: 197;
  }
  & ul.vds-listbox {
    margin-top: 0px;
  }
`;

export default styles;
